/**
 * Suggested outcomes for a foetus that did not continue (KIN-2066).
 *
 * Suggestions, not a closed list, and the field stays free text: the backend takes any outcome up
 * to 250 characters and there is no code set behind it. These are the two the hospital's lower
 * count almost always means, and offering them is what makes most entries land on the same words
 * without refusing the case that does not fit either.
 */
export const FOETUS_OUTCOME_SUGGESTIONS = ["Fetal demise", "Vanishing twin"];

/** The backend's own limit on the outcome column. */
export const FOETUS_OUTCOME_MAX_LENGTH = 250;
